import { useT } from 'apprise-frontend-core/intl/language'
import { Explainer } from 'apprise-ui/utils/explainer'
import { Label } from 'apprise-ui/label/label'
import { MultiSelectBox } from 'apprise-ui/selectbox/selectbox'
import { FaFlask } from 'react-icons/fa'


export const ToggleSettingSection = (props: {
    features: readonly string[]
    value: string[]
    onChange: (features: string[]) => void
}) => {
    const t = useT()
    return (
        <Explainer framed title={t('toggle.optional_features_title')}>
            <p>{t('toggle.optional_features_msg')}</p>
            <MultiSelectBox
                options={[...props.features]}
                placeholder={t('toggle.feature_placeholder')}
                render={feat => <Label titleStyle={{ fontStyle: 'normal', textTransform: 'uppercase' }} icon={<FaFlask />} title={feat} />}
                onChange={(selected) => props.onChange(selected ?? [])}
            >
                {props.value}
            </MultiSelectBox>
        </Explainer>
    )
}
